module.exports = __webpack_public_path__ + "static/media/starts_with_e.8b5ab77f.mp3";